import { Site } from '../../../models';

/* istanbul ignore file */
export class SitesComboboxModel {
    selectedSite: Site | null = null;
}
